import { memo, FC } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";

interface INotFound {}

const BackButton: FC<INotFound> = () => {
  const history = useHistory();

  return (
    <div className={styles.root} onClick={() => history.push("/chat")}>
      返回
    </div>
  );
};

export default memo(BackButton);
